import React from 'react';
import useStyle from './answer.style';

export interface AnswerProps {
  response: string;
  onClick: () => void;
  backgroundColor: 'orange' | 'violet' | 'blue';
}

const Answer = ({ response, onClick, backgroundColor }: AnswerProps) => {
  const classes = useStyle({ backgroundColor });
  return (
    <div onClick={onClick} className={classes.root}>
      <p className={classes.text}>{response}</p>
    </div>
  );
};

export default Answer;
